import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';

import FieldError from '../helpers/FieldError';

export default function DisplayErrorDecorator(Component) {
  const DisplayError = memo(({ error, ...rest }) => (
    <div className={classNames('clearfix', { 'has-error': error })}>
      <Component {...rest} />
      <FieldError message={error} />
    </div>
  ));

  DisplayError.propTypes = {
    error: PropTypes.string,
  };

  DisplayError.displayName = `DisplayError(${Component.displayName || Component.name})`;

  return DisplayError;
}
